import { classnames } from 'tailwindcss-classnames';

const NmdpSiteHeaderSkeleton = (): JSX.Element => {
  return (
    <div className="nmdp-header">
      {/* Mobile/Tablet Header Skeleton - Default to mobile layout to prevent shift */}
      <div className="border-gray-200 border-b bg-white">
        <div className={classnames('flex', 'items-center', 'justify-between', 'p-4')}>
          {/* Logo skeleton */}
          <div className="bg-gray-200 h-8 w-32 animate-pulse rounded" />

          {/* Right side buttons skeleton */}
          <div className="flex items-center space-x-2">
            <div className="bg-gray-200 h-8 w-8 animate-pulse rounded" />
            <div className="bg-gray-200 h-8 w-8 animate-pulse rounded" />
          </div>
        </div>
      </div>

      {/* Navigation skeleton - Hidden by default to match mobile behavior 
      <div className={classnames('hidden')}>
        <div className="border-gray-200 border-b bg-white p-4">
          <div className="space-y-2">
            {[...Array(5)].map((_, index) => (
              <div key={index} className="bg-gray-200 h-4 w-full animate-pulse rounded" />
            ))}
          </div>
        </div>
      </div>
      */}

      {/* Mobile bottom container skeleton for small screens */}
      <div className="border-gray-200 fixed bottom-0 left-0 right-0 border-t bg-white p-2 sm:hidden">
        <div className="flex justify-center space-x-4">
          <div className="bg-gray-200 h-10 flex-1 animate-pulse rounded" />
          <div className="bg-gray-200 h-10 flex-1 animate-pulse rounded" />
        </div>
      </div>
    </div>
  );
};

export default NmdpSiteHeaderSkeleton;
